'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import type { FC } from 'react';

export interface NavigationTab {
	id: string | number;
	label: string;
	link: string;
}

export interface NavigationTabsProps {
	tabs: NavigationTab[];
	onTabClick?: (tabId: string | number) => void;
	className?: string;
}

export const NavigationTabs: FC<NavigationTabsProps> = ({
	tabs,
	onTabClick,
	className = '',
}) => {
	const baseTabStyles = `
    px-6 py-2 rounded-lg text-sm font-medium transition-colors
    focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#D3F47F]
  `;

	const getTabStyles = (isActive: boolean) => `
    ${baseTabStyles}
    ${isActive ? 'bg-[#D3F47F] text-black' : 'text-gray-600 hover:bg-gray-100'}
  `;

	const pathname = usePathname();

	return (
		<div className={`flex gap-2 ${className}`}>
			{tabs.map((tab) => {
				const isActive = pathname === tab.link;
				const tabContent = (
					<span className={getTabStyles(isActive)}>{tab.label}</span>
				);

				return (
					<div key={tab.id}>
						{tab.link ? (
							<Link
								href={tab.link}
								onClick={() => onTabClick?.(tab.id)}
								className="focus:outline-none"
							>
								{tabContent}
							</Link>
						) : (
							<button
								type="button"
								onClick={() => onTabClick?.(tab.id)}
								className={getTabStyles(isActive)}
							>
								{tab.label}
							</button>
						)}
					</div>
				);
			})}
		</div>
	);
};
